import React, { useContext, useState } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AuthenticationContext } from 'auth/AuthProvider';
import { NeedAssistanceModal } from './NeedAssistanceModal';
import { useLogin } from './hooks';
import { resolver } from './constants';

export default () => {
  const [showAssistanceModal, setShowAssistanceModal] = useState(false);
  const { isLoggedIn } = useContext(AuthenticationContext);
  const { login } = useLogin();

  const toggleAssistanceModal = () => setShowAssistanceModal((prev) => !prev);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ resolver });

  if (isLoggedIn) return <Redirect to="/" />;

  return (
    <div className="login-wrapper">
      <div className="login-banner px-3 px-md-0" />
      <div className="container my-md-3">
        <h3 className="login-header mb-0 mb-md-3 text-center">
          Welcome to Your DonorsTrust Dashboard
        </h3>
        <div className="row">
          <div className="col col-sm-8 offset-sm-2 col-md-6 offset-md-3">
            <Form
              className="form my-4"
              onSubmit={handleSubmit((values) => login(values))}
              autoComplete="off"
            >
              <Form.Row className="align-items-center mx-0">
                <Form.Label className="pr-3 pl-0 col-auto col-md-4" align="right">
                  Username:
                </Form.Label>
                <Form.Control
                  className="col-12 col-md-8"
                  {...register('username')}
                  isInvalid={errors.username}
                  type="text"
                />
              </Form.Row>
              <Form.Row className="mt-3 align-items-center mx-0">
                <Form.Label className="pr-3 pl-0 col-auto col-md-4" align="right">
                  Password:
                </Form.Label>
                <Form.Control
                  className="col-12 col-md-8"
                  type="password"
                  {...register('password')}
                  isInvalid={errors.password}
                  autoComplete="new-password"
                />
              </Form.Row>
              <Form.Row className="mx-0">
                <div className="offset-md-4 w-100">
                  <button
                    className="button button--dark-blue mt-3 px-4 py-3 py-md-2 w-100"
                    type="submit"
                  >
                    Login
                  </button>
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    <Link to="/password/reset" className="mr-3 text-black">
                      <u>Reset Password</u>
                    </Link>
                    <button
                      type="button"
                      className="login-assistance-trigger"
                      onClick={toggleAssistanceModal}
                    >
                      <u>Need Assistance?</u>
                    </button>
                  </div>
                </div>
              </Form.Row>
            </Form>
          </div>
        </div>
      </div>
      <NeedAssistanceModal show={showAssistanceModal} onHide={toggleAssistanceModal} />

      <div className="bottom-banner" />
    </div>
  );
};
